import moment from 'moment'
import { useTimer } from 'react-timer-hook'

import { useManagementCreateUnitActive } from '@apps-common/apis/management/unit-active'
import { ButtonRoundedSm } from '@apps-common/components/elements/button'
import { ModalBody, ModalContainer, ModalFooter } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { INonAllocatedSimModel } from '@apps-common/types/management/non-allocated-sim'
import { IUnitCreateMultipleDefaultsModel } from '@apps-common/types/management/unit'

import { VertSpacerMd } from '../../../../../../../../components/layout'

export const UnitSaveTimerModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: {
    defaults: IUnitCreateMultipleDefaultsModel
    extraDetails: {
      imei: string
      serialNo: string
      accountNo?: string
    }
    nonAllocatedSim: INonAllocatedSimModel
  }
}) => {
  const { defaults, extraDetails, nonAllocatedSim } = componentProps
  const { mutate: createUnit, isPending: createIsPending } = useManagementCreateUnitActive(true, (unit) =>
    onDismiss(JSON.stringify({ ...defaults, ...extraDetails, ...nonAllocatedSim }), ModalDismiss.Confirm)
  )

  const saveAndClose = () => {
    createUnit({
      model: {
        unitId: '',
        productId: defaults.productId,
        monitoringCentreId: defaults.monitoringCentreId,
        bureauId: defaults.bureauId,
        techCompanyId: defaults.techCompanyId,
        unitPlanId: defaults.unitPlanId,
        unitFirmwareId: defaults.unitFirmwareId,
        accountNo: extraDetails.accountNo || defaults.accountNo,
        imei: extraDetails.imei,
        serialNo: extraDetails.serialNo,
        keepActive: true,
        lineSupervision: defaults.lineSupervision,
        isActivated: defaults.isActivated,
        hardwareToBeInvoiced: defaults.hardwareToBeInvoiced,
        simId: '',
        simApnId: nonAllocatedSim.simApnId,
        simTypeId: defaults.simTypeId,
        mobileNo: nonAllocatedSim.mobileNo,
        simNo: nonAllocatedSim.simNo,
        ip: nonAllocatedSim.ip,
        dateLoaded: moment().toISOString(),
        userId: 0
      },
      nonAllocatedSimId: nonAllocatedSim.id
    })
  }

  const { seconds, isRunning, pause, restart } = useTimer({
    expiryTimestamp: moment().add(5, 'second').toDate(),
    autoStart: defaults.autoSave,
    onExpire: () => {
      saveAndClose()
    }
  })

  return (
    <ModalContainer classes='!items-center px-[1rem]' innerClasses='rounded-3xl !min-h-0 !h-auto sm:!min-w-[300px] !w-auto'>
      <ModalBody classes='!pt-[1rem]'>
        <p className='text-secondary-content text-[0.9em] px-[5px]'>
          <div className='text-[1.2rem]'>Device validated</div>
          <VertSpacerMd />
          {!defaults.autoSave && <div>Select save to continue adding next device.</div>}
          {defaults.autoSave && (
            <div className='bg-secondary-content/5 rounded-3xl p-4 flex flex-col items-center justify-center gap-2'>
              <div>Saving device</div>
              <div className='bg-secondary-content/10 flex items-center justify-center w-[40px] h-[40px] rounded-2xl'>{seconds}</div>
            </div>
          )}
        </p>
      </ModalBody>
      <ModalFooter>
        <div className='w-full flex items-center justify-start gap-2'>
          {!defaults.autoSave && <ButtonRoundedSm type='button' text='Save' loading={createIsPending} callback={() => saveAndClose()} />}
          <ButtonRoundedSm type='button' text='Cancel' loading={createIsPending} callback={() => onDismiss(null, 'cancel')} />
        </div>
      </ModalFooter>
    </ModalContainer>
  )
}
